/**
 * Imports various chart modules and exports them as a single object.
 * This allows for easy access to all chart functions from a single import.
 */

import * as histogram from './histogram.js';
import * as pie_chart from './pie_chart.js';
import * as stats_number from './stats_number.js';
import * as progress_bar from './progress_bar.js';
import * as area_chart from './area_chart.js';
import * as svg from './svg.js';
import * as bar_chart from './bar_chart.js';
import * as box_plot from './box_plot.js';
import * as line_chart from './line_chart.js';

export default {
    histogram,
    pie_chart,
    stats_number,
    progress_bar,
    area_chart,
    svg,
    bar_chart,
    box_plot,
    line_chart,
};
